import { MASTER_BUSINESS_MESSAGE_CONSTANTS } from '../../translate-messages/ngrx-store/master-business';
import { API_METHOD_CONSTANTS } from '../core';

export const MASTER_BUSINESS_METHOD_CONSTANT = {
  PUBLIC_HOLIDAY: 'Public Holiday',
  BUSINESS_ROLE: 'Business Role',
  TRAINING_LICENSE: 'Training License',
  STRESS_PROFILE: 'Stress Profile',
  LEAVE: 'Leave',
  EMPLOYEE_ROLE: 'Employee Roles',
  LOG: 'LOG',
  SERVER_LOG: 'SERVER_LOG',
  DAILY_REPORT: 'DAILY_REPORT',
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  EMAIL_LOG: 'EMAIL_LOG',
};

export const MASTER_BUSINESS_NGRX_CONSTANTS = {
  [MASTER_BUSINESS_METHOD_CONSTANT.DAILY_REPORT]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'dailyReportPaging',
      STATE: 'businessRolePaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
  },

  [MASTER_BUSINESS_METHOD_CONSTANT.PUSH_NOTIFICATION]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'notificationPaging',
      STATE: 'businessRolePaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'notificationExport',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      CACHING: false,
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
  },

  [MASTER_BUSINESS_METHOD_CONSTANT.EMAIL_LOG]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'emailPaging',
      STATE: 'businessRolePaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'emailExport',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      CACHING: false,
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
  },


  [MASTER_BUSINESS_METHOD_CONSTANT.LOG]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'logPaging',
      STATE: 'businessRolePaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'logExport',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      CACHING: false,
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
  },
  [MASTER_BUSINESS_METHOD_CONSTANT.SERVER_LOG]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'serverLogPaging',
      STATE: 'businessRolePaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'serverLogExport',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      CACHING: false,
      API_RESPONSE: 'data',
      INDIVIDUAL: false,
    },
  },
  [MASTER_BUSINESS_METHOD_CONSTANT.BUSINESS_ROLE]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getBusinessrole',
      STATE: '',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      INDIVIDUAL: false,
      CACHING: true,
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addBusinessRole',
      STATE: 'businessRoleDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PENDING_BUSINESS_USER,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_INSERT_BUSINESS_ROLE,
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data.business_role[0]',
      INDIVIDUAL: false,

    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateBusinessRole',
      STATE: 'businessRoleDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PENDING_BUSINESS_USER,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_UPDATE_BUSINESS_ROLE,
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data.business_role[0]',
      INDIVIDUAL: false,

    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getBusinessRolePaging',
      STATE: 'businessRolePaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      UNIQUE_KEY: 'business_role_id',
      API_RESPONSE: 'data',
      INDIVIDUAL: false,

    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getBusinessRoleAll',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      CACHING: false,
      API_RESPONSE: 'data',
      INDIVIDUAL: false,

    },
  },
  [MASTER_BUSINESS_METHOD_CONSTANT.PUBLIC_HOLIDAY]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getPublicHoliday',
      STATE: 'publichHolidayDetails',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PUBLIC_HOLIDAY,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_PUBLIC_HOLIDAY_ADD,
      INDIVIDUAL: true,
      CACHING: true,
      UNIQUE_KEY: 'public_holiday_id',
      API_RESPONSE: 'data.public_holidays[0]',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addPublicHoliday',
      STATE: 'publichHolidayDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PUBLIC_HOLIDAY,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_PUBLIC_HOLIDAY_ADD,
      INDIVIDUAL: true,
      UNIQUE_KEY: 'public_holiday_id',
      API_RESPONSE: 'data.public_holidays[0]',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updatePublicHoliday',
      STATE: 'publichHolidayDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PUBLIC_HOLIDAY,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_PUBLIC_HOLIDAY_UPDATE,
      UNIQUE_KEY: 'public_holiday_id',
      API_RESPONSE: 'data.public_holidays[0]',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getPublicHolidayPagging',
      STATE: 'publicHolidayList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PUBLIC_HOLIDAY,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_PUBLIC_HOLIDAY_UPDATE,
      UNIQUE_KEY: 'public_holiday_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getPublicHolidayAll',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PUBLIC_HOLIDAY,
      CACHING: false,
      API_RESPONSE: 'data.public_holidays',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deletePublicHoliday',
      STATE: 'publichHolidayDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_PUBLIC_HOLIDAY,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_PUBLIC_HOLIDAY_DELETE,
      UNIQUE_KEY: 'public_holiday_id',
      API_RESPONSE: 'data',
    },
  },
  [MASTER_BUSINESS_METHOD_CONSTANT.TRAINING_LICENSE]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getTrainingLicense',
      STATE: 'trainingLicenseDetails',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_TRAINING_LICENSE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_TRAINING_LICENSE_ADD,
      INDIVIDUAL: true,
      CACHING: true,
      UNIQUE_KEY: 'training_licence_id',
      API_RESPONSE: 'data.training_licence[0]',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addTrainingLicense',
      STATE: 'trainingLicenseDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_TRAINING_LICENSE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_TRAINING_LICENSE_ADD,
      INDIVIDUAL: true,
      UNIQUE_KEY: 'training_licence_id',
      API_RESPONSE: 'data.training_licence[0]',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateTrainingLicense',
      STATE: 'trainingLicenseDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_TRAINING_LICENSE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_TRAINING_LICENSE_UPDATE,
      UNIQUE_KEY: 'training_licence_id',
      API_RESPONSE: 'data.training_licence[0]',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getTrainingLicensePagging',
      STATE: 'trainingLicenseList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_TRAINING_LICENSE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_TRAINING_LICENSE_UPDATE,
      UNIQUE_KEY: 'training_licence_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteTrainingLicense',
      STATE: 'trainingLicenseDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_TRAINING_LICENSE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_TRAINING_LICENSE_DELETE,
      UNIQUE_KEY: 'training_licence_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getTrainingLicenseAll',
      STATE: 'trainingLicenseAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_TRAINING_LICENSE,
      CACHING: false,
      API_RESPONSE: 'data.training_licence',
    },
  },
  [MASTER_BUSINESS_METHOD_CONSTANT.STRESS_PROFILE]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getStressProfile',
      STATE: 'stressProfileDetails',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_STRESS_PROFILE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_STRESS_PROFILE_ADD,
      INDIVIDUAL: true,
      CACHING: true,
      UNIQUE_KEY: 'business_stress_profile_id',
      API_RESPONSE: 'data.business_stress_profile[0]',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addStressProfile',
      STATE: 'stressProfileDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_STRESS_PROFILE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_STRESS_PROFILE_ADD,
      INDIVIDUAL: true,
      UNIQUE_KEY: 'business_stress_profile_id',
      API_RESPONSE: 'data.business_stress_profile[0]',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateStressProfile',
      STATE: 'stressProfileDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_STRESS_PROFILE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_STRESS_PROFILE_UPDATE,
      //   INDIVIDUAL: true,
      UNIQUE_KEY: 'business_stress_profile_id',
      API_RESPONSE: 'data.business_stress_profile[0]',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getStressProfilePagging',
      STATE: 'stressProfileList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_STRESS_PROFILE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_STRESS_PROFILE_UPDATE,
      UNIQUE_KEY: 'business_stress_profile_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteStressProfile',
      STATE: 'stressProfileDetails',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_STRESS_PROFILE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_STRESS_PROFILE_DELETE,
      UNIQUE_KEY: 'business_stress_profile_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_LOOKUP]: {
      API_METHOD: 'getStressProfileLookUp',
      STATE: 'stressProfileLookup',
      API_RESPONSE: 'data.business_stress_profile',
      SUCCESS_NOTIFICATION: false,
      CACHING: false,
      TITLE: '',
      MESSAGE: '',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getStressProfileAll',
      STATE: 'stressProfileAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_STRESS_PROFILE,
      CACHING: false,
      API_RESPONSE: 'data.business_stress_profile',
    },
  },
  [MASTER_BUSINESS_METHOD_CONSTANT.LEAVE]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getLeave',
      STATE: 'leaveDeatils',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_LEAVE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_LEAVE_ADD,
      INDIVIDUAL: true,
      CACHING: true,
      UNIQUE_KEY: 'leave_id',
      API_RESPONSE: 'data.masterLeaves[0]',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addLeave',
      STATE: 'leaveDeatils',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_LEAVE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_LEAVE_ADD,
      INDIVIDUAL: true,
      UNIQUE_KEY: 'leave_id',
      API_RESPONSE: 'data.masterLeaves[0]',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateLeave',
      STATE: 'leaveDeatils',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_LEAVE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_LEAVE_UPDATE,
      UNIQUE_KEY: 'leave_id',
      API_RESPONSE: 'data.masterLeaves[0]',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'updateLeave',
      STATE: 'leaveDeatils',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_LEAVE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_LEAVE_UPDATE,
      UNIQUE_KEY: 'leave_id',
      API_RESPONSE: 'data.masterLeaves[0]',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getLeavePagging',
      STATE: 'leaveList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_LEAVE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_LEAVE_UPDATE,
      UNIQUE_KEY: 'leave_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteLeave',
      STATE: 'leaveDeatils',
      SUCCESS_NOTIFICATION: true,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_LEAVE,
      SUCCESS: MASTER_BUSINESS_MESSAGE_CONSTANTS.SUCCESS_LEAVE_DELETE,
      UNIQUE_KEY: 'leave_id',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_LOOKUP]: {
      API_METHOD: 'getMasterLeaveLookup',
      STATE: 'masterLeaveLookup',
      API_RESPONSE: 'data.masterLeaves',
      SUCCESS_NOTIFICATION: false,
      CACHING: false,
      TITLE: '',
      MESSAGE: '',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getLeaveAll',
      STATE: 'leaveAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: MASTER_BUSINESS_MESSAGE_CONSTANTS.TITLE_LEAVE,
      CACHING: false,
      API_RESPONSE: 'data.masterLeaves',
    },
  },
  [MASTER_BUSINESS_METHOD_CONSTANT.EMPLOYEE_ROLE]: {
    [API_METHOD_CONSTANTS.GET_LOOKUP]: {
      API_METHOD: 'getEmployeeRoleList',
      STATE: 'employeeRoleLookup',
      API_RESPONSE: 'data.business_role',
      CACHING: false,
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      MESSAGE: '',
    },
  },
};
